import { Link } from 'react-router-dom';
import { useLanguage } from '../../../hooks/useLanguage';
import { t } from '../../../utils/translations';
import './versions-link.css';

// Unobtrusive button shown on each release page that links to the
// dedicated Versions page listing every available release route.
function VersionsLink() {
    const { currentLanguage } = useLanguage();
    const label = t('check_other_versions', currentLanguage);
    const shortLabel = t('check_other_versions_short', currentLanguage);

    return (
        <Link
            to="/versions"
            className="versions-link"
            title={label}
            aria-label={label}
        >
            <svg
                className="versions-link-icon"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
            >
                <rect x="3" y="4" width="18" height="4" rx="1" stroke="currentColor" strokeWidth="2" />
                <rect x="3" y="10" width="18" height="4" rx="1" stroke="currentColor" strokeWidth="2" />
                <rect x="3" y="16" width="18" height="4" rx="1" stroke="currentColor" strokeWidth="2" />
            </svg>
            <span className="versions-link-text versions-link-text-full">{label}</span>
            <span className="versions-link-text versions-link-text-short">{shortLabel}</span>
        </Link>
    );
}

export default VersionsLink;
